import { styled, Box } from "@mui/material";

const Column = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
});

export default Column;
